/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Mode_FixedInputs */

const vi_irrigation_schedule_mode_fixed = /** @type {(inputs: Irrigation_Schedule_Mode_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giờ cố định`)
};

/**

* @param {Irrigation_Schedule_Mode_FixedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_mode_fixed = /** @type {((inputs?: Irrigation_Schedule_Mode_FixedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Mode_FixedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_mode_fixed(inputs)
});